import { render, staticRenderFns } from "./RainfallTable.vue?vue&type=template&id=374bd8b4&scoped=true"
import script from "./RainfallTable.vue?vue&type=script&lang=ts"
export * from "./RainfallTable.vue?vue&type=script&lang=ts"
import style0 from "./RainfallTable.vue?vue&type=style&index=0&id=374bd8b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "374bd8b4",
  null
  
)

export default component.exports